import classNames from 'classnames';
import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
const MyAccountSection = (props) => {
    const { t } = useTranslation();
    const { id, title, children, saved } = props;
    const currentSection = useRef();
    const saveBanner = useRef();
    // disabled due to https://jira.industries-group.com/browse/ONE-30046
    useEffect(() => {
        if (saved && saveBanner.current) {
            saveBanner.current.focus();
        }
    }, [saved]);
    return (React.createElement("div", { ref: currentSection, tabIndex: -1, className: classNames('myaccount__section', { short: props.isShort }), id: id },
        (props.title || props.titleAction) && (React.createElement("div", { className: classNames('myaccount__section-header', { 'no-content': !props.children }) },
            props.isTitleMarkup ? props.title : React.createElement("h2", { className: "title" }, title),
            props.titleAction)),
        saved && (React.createElement("span", { className: "alert alert--success alert--temp visually-hidden", tabIndex: -1, role: "alert", ref: saveBanner }, t('label.saved'))),
        props.children));
};
export default MyAccountSection;
